import {Box, Modal, ModalProps, Text} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {GeofenceEventEntity} from "@ots-frontend/ots-data";
import { DefaultText } from "../../../text/DefaultText/DefaultText";
import { FormattedDateTime } from "../../../date/FormattedDateTime/FormattedDateTime";
import { FormattedQuantity } from "../../../text/FormattedQuantity/FormattedQuantity";

export interface GeofenceEventModalProps extends ModalProps {
  geofenceEvent: GeofenceEventEntity
}

export const GeofenceEventModal = (props: GeofenceEventModalProps) => {
  const {
    geofenceEvent,
    title,
    ...rest
  } = props;

  const {t} = useTranslation(["common"]);

  return (
    <Modal {...rest} title={title ? title : t("common.entity.geofenceevent", "Geofence Event")}>
      <Box>
        <Text ta="left" fz="sm" weight={500} mt="md">
          {t("common.entity.geofenceevent.field.site.label", "Site")}
        </Text>
        <Text ta="left" c="dimmed" fz="xs">
          <DefaultText value={geofenceEvent.siteName}/>
        </Text>
        <Text ta="left" fz="sm" weight={500} mt="md">
          {t("common.entity.geofenceevent.field.person.label", "Person")}
        </Text>
        <Text ta="left" c="dimmed" fz="xs">
          <DefaultText value={geofenceEvent.personName}/>
        </Text>
        <Text ta="left" fz="sm" weight={500} mt="md">
          {t("common.entity.geofenceevent.field.in.label", "In Date")}
        </Text>
        <Text ta="left" c="dimmed" fz="xs">
          {geofenceEvent.inDttm &&
            <FormattedDateTime date={geofenceEvent.inDttm}/>
          }
        </Text>
        <Text ta="left" fz="sm" weight={500} mt="md">
          {t("common.entity.geofenceevent.field.out.label", "Out Date")}
        </Text>
        <Text ta="left" c="dimmed" fz="xs">
          {geofenceEvent.outDttm &&
            <FormattedDateTime date={geofenceEvent.outDttm}/>
          }
        </Text>
        <Text ta="left" fz="sm" weight={500} mt="md">
          {t("common.entity.geofenceevent.field.duration.label", "Duration")}
        </Text>
        <Text ta="left" c="dimmed" fz="xs">
          {geofenceEvent.durationInMillis &&
            <FormattedQuantity value={{number: geofenceEvent.durationInMillis / 60000, units: "minutes"}} />
          }
        </Text>
      </Box>
    </Modal>
  );
};
